module.exports = __webpack_public_path__ + "static/media/imgSocialMedia.894916ae.jpg";